import React from 'react';
import {connect} from "react-redux";
import {getIngredients} from "../../actions/getFirestoreData/getIngredients";
import {getRecipesByIngredientSearch} from "../../actions/getFirestoreData/getRecipesByIngredient";
import RecipeCard from "./RecipeCard";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Grid, Button, TextField, LinearProgress} from "@material-ui/core";


/**
 * This class is used to search recipes quickly thanks to ingredients we could selected
 */
class SearchRecipe extends React.Component {
    state = {
        allIngredients: [],
        isLoading: true,
        myRecipes: [],
        ingredientsToSearch: []
    };
    _isMounted = false;

    componentDidMount = async () => {
        this._isMounted = true;
        let allIngredients = await this.props.getIngredients();

        if (this._isMounted) {
            this.setState({
                allIngredients,
                isLoadingMyFavorite: false,
            });
        }
    };

    searchRecipe = async () => {
        let myRecipes = await this.props.getRecipesByIngredientSearch(this.state.ingredientsToSearch);
        this.setState({myRecipes});
    };

    componentWillUnmount = () => {
        this._isMounted = false;
    };

    handleChange = (e, value) => {
        this.setState({ingredientsToSearch: value});
    };

    render() {
        const {isLoading, myRecipes, allIngredients} = this.state;
        if (!isLoading) return <LinearProgress/>;

        return (
            <Grid container direction="row" justify="space-evenly" alignItems="center">
                <Grid container item direction="column" justify="center" alignItems="center" xs={8}>
                    <Autocomplete style={{minWidth: 200}} multiple id="tags-standard"
                                  options={allIngredients}
                                  getOptionLabel={(option) => option}
                                  onChange={this.handleChange}
                                  renderInput={(params) => (
                                      <TextField {...params} variant="standard"
                                                 label="ingredients de la recette" placeholder="Ingredients"
                                      />)}
                    />
                    <Button onClick={this.searchRecipe}>Search</Button>
                </Grid>

                <Grid item xs={12} container direction="row" justify="space-around" spacing={4}>
                    {
                        myRecipes.map(recipe => (
                            <Grid item xs={12} sm={6} lg={4} key={recipe.name} container direction="row" justify="space-around">
                                <RecipeCard recipe={recipe}/>
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
        );
    }
}


export default connect(
    null,
    {getIngredients, getRecipesByIngredientSearch}
)(SearchRecipe)
